import { Formik } from "formik";
import { Divider, Grid, TextField, Typography, FormLabel, Select, MenuItem, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useCompanyStore } from "../../../hooks/useCompanyStore";

type Values = {
    id: number,
    rut: string,
    business_name: string,
    address: string,
    email: string,
    phone: string,
}

export const CompanyModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, companySelected, listCompany, clearState } = props;

    const { action, createCompany, editCompany } = useCompanyStore();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Values>({
        id: companySelected ? companySelected.id :'',
        rut: companySelected ? companySelected.rut :'',
        business_name: companySelected ? companySelected.business_name :'',
        address: companySelected ? companySelected.address :'',
        email: companySelected ? companySelected.email :'',
        phone: companySelected ? companySelected.phone :'',
    });

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.rut) errors.rut = "el campo es requerido";
        if(!values.business_name) errors.business_name = "el campo es requerido";
        if(!values.address) errors.address = "el campo es requerido";
        if(!values.email) errors.email = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(companySelected){
            const response:any = await editCompany(companySelected.id, values);
            if(response){
                listCompany && listCompany();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createCompany(values);
            if(response){
                listCompany && listCompany();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar compañia' : (action == 'add' ? 'Nueva compañia' : 'Detalle de la compañia')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="business_name"
                                                type="text" 
                                                name="business_name"
                                                fullWidth
                                                size="small"
                                                value={values.business_name}
                                                onChange={handleChange}
                                                error={errors.business_name && touched.business_name ? true : false}
                                                helperText={errors.business_name && touched.business_name ? errors.business_name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Rut:</FormLabel>
                                            <TextField
                                                id="rut"
                                                type="text" 
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={values.rut}
                                                onChange={handleChange}
                                                error={errors.rut && touched.rut ? true : false}
                                                helperText={errors.rut && touched.rut ? errors.rut : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormLabel>Dirección:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text" 
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                error={errors.address && touched.address ? true : false}
                                                helperText={errors.address && touched.address ? errors.address : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Correo:</FormLabel>
                                            <TextField
                                                id="email"
                                                type="email" 
                                                name="email"
                                                fullWidth
                                                size="small"
                                                value={values.email}
                                                onChange={handleChange}
                                                error={errors.email && touched.email ? true : false}
                                                helperText={errors.email && touched.email ? errors.email : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Teléfono:</FormLabel>
                                            <TextField
                                                id="phone"
                                                type="text" 
                                                name="phone"
                                                fullWidth
                                                size="small"
                                                value={values.phone}
                                                onChange={handleChange}
                                                error={errors.phone && touched.phone ? true : false}
                                                helperText={errors.phone && touched.phone ? errors.phone : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}